<template>
  <base-list-overview
    controller="Request"
    :filter="Filter"
    redirect
    redirect-page="Requests"
    tab="requests"
    :visible="visible"
  />
</template>

<script>
import BaseListOverview from '@/components/shared/base/base-list-overview'
import ContentMixin from '@/mixins/content-mixin'

export default {
  name: 'ChildrenRequests',
  components: {
    BaseListOverview
  },
  mixins: [
    ContentMixin
  ],
  computed: {
    Filter () {
      const key = 'idChild'
      return [
        {
          key: key,
          value: this.ContentMixin_Element[key]
        }
      ]
    }
  }
}
</script>
